import { useNavigate } from "react-router";
import { getEngagementRate } from "../../services/getEngagementRate";

/**
 * @typedef {import('react-router').NavigateFunction} NavigateFunction
 */

/**
 * Processes event analytics data, calculates rates, and navigates to the analytics page.
 *
 * @param {string} eventId - The unique identifier for the event.
 * @param {string | number} taps - The raw number of total taps (string or number).
 * @param {string | number} engagement - The engagement rate value.
 * @param {string | number} postClick - The raw number of post-click actions.
 * @param {string | number} attendance - The raw number of attendees (may contain commas).
 * @param {NavigateFunction} navigate - The navigate function obtained from the `useNavigate` hook.
 * @returns {void} This function does not return a value; it performs navigation as a side effect.
 */
export const handleAnalyticsClick = (eventId, taps, engagement, postClick, attendance, navigate) => {

    // Data Sanitization and Conversion
    const tapsNum = Number(taps) || 0;
    const postClickNum = Number(postClick) || 0;
    // Remove commas from attendance string before converting to number
    const attendanceNum = Number(String(attendance).replace(/,/g, '')) || 0;

    // Rate Calculation
    // Assuming getEngagementRate handles the calculation logic (e.g., PostClicks / Attendance * 100)
    const postClickRate = getEngagementRate(attendanceNum, postClickNum);

    // Navigation and State Passing
    navigate(`/admin/analytics/${eventId}`, {
        state: {
            totalTaps: tapsNum,
            engagementRate: `${engagement}`, // Ensures it's passed as a string
            postClickRate: `${postClickRate}`, // Ensures it's passed as a string
            attendance: attendanceNum, // Passing the cleaned/numeric value
            postClickNum: postClickNum
        }
    });
};